import React from "react";
import PlaceholderBackground from "../utils/PlaceholderBackground.jsx";
import useLottiePlayer from "../../hooks/useLottiePlayer.jsx";

const FULL_SIZE_STYLE = { width: "100%", height: "100%" };

const placeholderIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{ width: 48, height: 48 }}>
    <path
      d="M13.949 2H6.05A4.053 4.053 0 0 0 2 6.051v7.898A4.053 4.053 0 0 0 6.051 18h7.898A4.053 4.053 0 0 0 18 13.949V6.05A4.053 4.053 0 0 0 13.949 2Zm.769 4.933a.808.808 0 0 1-.564.236c-1.672 0-2.318 1.016-3.19 2.698l-.533 1.015c-.82 1.58-1.836 3.549-4.595 3.549a.792.792 0 1 1 0-1.59c1.672 0 2.318-1.015 3.19-2.697l.533-1.016c.82-1.58 1.836-3.549 4.595-3.549a.79.79 0 0 1 .554 1.354h.01Z"
      fill="#fff"
    />
  </svg>
);

const placeholderInstrux = (
  <span>
    <span>Select Lottie source in property panel&nbsp;&#8594;</span>
  </span>
);

/**
 * Lottie animation renderer component.
 * Renders a DotLottie animation that auto-plays when selected, or a placeholder when no source is configured.
 *
 * @param {Object} props
 * @param {Object} props.content - Immutable Map containing the Lottie source configuration.
 * @param {Object} props.elemProps - Immutable Map of element properties (dimensions, etc.).
 * @param {string} props.id - The element ID.
 * @param {string} props.layout - The current layout (desktop/mobile).
 * @param {boolean} props.isSelected - Whether this element is currently selected.
 * @returns {React.ReactElement}
 */
const Lottie = ({ content, elemProps, id, layout, isSelected }) => {
  const { containerRef, isLoading } = useLottiePlayer({
    content,
    elemProps,
    id,
    layout,
    isSelected,
  });

  return (
    <div
      data-testid="lottie-renderer"
      style={{
        ...FULL_SIZE_STYLE,
        position: "relative",
      }}
      className="lottie-animation-container"
    >
      <div
        ref={containerRef}
        style={{ ...FULL_SIZE_STYLE, visibility: isLoading ? "hidden" : "visible" }}
      />

      {isLoading && (
        <div style={{ ...FULL_SIZE_STYLE, position: "absolute", top: 0, left: 0 }}>
          <PlaceholderBackground icon={placeholderIcon} instrux={placeholderInstrux} />
        </div>
      )}
    </div>
  );
};

export default Lottie;
